/**
 * Centralized API Configuration
 * Manages API URLs for different environments
 */
import logger from "./lib/logger";

// Get API URL from environment variable
// Production: https://api.kzool.com
// Development: http://localhost:8000
const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.kzool.com'
    : 'http://localhost:8000');

// Get App URL from environment variable
// Production: https://app.kzool.com
// Development: http://localhost:3000
const APP_URL = process.env.REACT_APP_APP_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://app.kzool.com' 
    : 'http://localhost:3000');

// API base path (versioned). The backend also keeps the legacy unversioned
// `/api/*` working as a transitional alias.
export const API = `${API_URL}/api/v1`;

// Backend URL (for static file URLs like avatars, images)
export const BACKEND_URL = API_URL;

// Get Site URL (marketing / vitrine) from environment variable
// Production: https://kzool.com
// Development: http://localhost:3000
const SITE_URL = process.env.REACT_APP_SITE_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://kzool.com'
    : 'http://localhost:3000');

// App URL (for redirects, links, etc.)
// Site URL (marketing vitrine)
export { APP_URL, SITE_URL };

// Business timezone — the calendar day the backend means by "today".
// MUST stay in sync with `CASA_TZ` in backend `core/reservation_query.py`: the
// sidebar "today" counts are resolved server-side in this zone, so any frontend
// date compared against them (see `utils/today.js`) has to use it too, or a
// viewer in another zone sees a count and a highlight that disagree.
export const BUSINESS_TIMEZONE = "Africa/Casablanca";

// Log in development
if (process.env.NODE_ENV !== 'production') {
  logger.log('API URL:', API);
  logger.log('Backend URL:', BACKEND_URL);
  logger.log('App URL:', APP_URL);
  logger.log('Site URL:', SITE_URL);
}

